import { WORKY_WEB_APP_PATHS } from '../../../WorkyWebAppPaths';

const EDIT_WORK_TASK_TEMPLATE_ID_QUERY_KEY: string = 'templateId';

const buildEditWorkTaskTemplatePath = (templateId: string): string => {
  return `${WORKY_WEB_APP_PATHS.agencyCreateWorkTaskTemplate}?${EDIT_WORK_TASK_TEMPLATE_ID_QUERY_KEY}=${encodeURIComponent(templateId)}`;
};

export {
  EDIT_WORK_TASK_TEMPLATE_ID_QUERY_KEY,
  buildEditWorkTaskTemplatePath,
};
